import { render, staticRenderFns } from "./InvisibleIDdetectionDia.vue?vue&type=template&id=22eccdb0&scoped=true"
import script from "./InvisibleIDdetectionDia.vue?vue&type=script&lang=js"
export * from "./InvisibleIDdetectionDia.vue?vue&type=script&lang=js"
import style0 from "./InvisibleIDdetectionDia.vue?vue&type=style&index=0&id=22eccdb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eccdb0",
  null
  
)

export default component.exports